import { useSystemConfig } from "../../../context/systemConfigContext";

export const ConfirmDialog = ({
    selectedAppointment,
    handleUpdate,
    loading,
}) => {
    const { logo, config } = useSystemConfig();

    const formatDateLong = (dateStr) => {
        if (!dateStr) return "";
        const date = new Date(dateStr + "T00:00:00");
        const dayName = date.toLocaleDateString("es-ES", { weekday: "long" });
        const dayNum = date.getDate();
        const month = date.toLocaleDateString("es-ES", { month: "short" }).replace(".", "");
        return `${dayName.charAt(0).toUpperCase() + dayName.slice(1)} ${dayNum} ${month.charAt(0).toUpperCase() + month.slice(1)}`;
    };

    return (
        <div className="flex flex-col h-full w-full max-w-md mx-auto bg-white">
            {/* Header */}
            <div className="pt-8 pb-4 px-6 text-center">
                <img src={logo} alt="Logo" className="h-16 mx-auto mb-5 object-contain" />
                <h2 className="text-2xl font-bold text-gray-900">
                    Confirmar turno
                </h2>
            </div>

            {/* Content */}
            <div className="flex-1 px-6 pt-8">
                {loading && (
                    <div className="flex items-center justify-center">
                        <div className="w-5 h-5 border-2 border-gray-500 border-t-transparent rounded-full animate-spin"></div>
                    </div>
                )}

                {selectedAppointment && selectedAppointment.status < 3 && (
                    <>
                        <p className="text-gray-600 text-base mb-4">
                            Hola{" "}
                            <strong className="text-gray-900">
                                {selectedAppointment.patient.firstName}{" "}
                                {selectedAppointment.patient.lastName}
                            </strong>{" "}
                            👋
                        </p>
                        <p className="text-gray-600 text-base mb-8">
                            Tu turno con {selectedAppointment.doctor.sex === 2 ? "la" : "el"}{" "}
                            <strong className="text-gray-900">
                                {selectedAppointment.doctor.sex === 2 ? "Dra." : "Dr."}{" "}
                                {selectedAppointment.doctor.firstName}{" "}
                                {selectedAppointment.doctor.lastName}
                            </strong>
                            {config?.hospital_name && (
                                <>
                                    , en el{" "}
                                    <strong className="text-gray-900">
                                        {config.hospital_name}
                                    </strong>
                                </>
                            )}
                            , está reservado temporalmente.
                        </p>

                        <div className="flex items-center justify-center border border-gray-200 rounded-2xl py-8 px-6 w-fit mx-auto shadow-md">
                            <div className="flex items-center gap-2 pr-4 border-r border-gray-200">
                                <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                </svg>
                                <span className="text-gray-800 font-medium text-sm">
                                    {formatDateLong(selectedAppointment.date)}
                                </span>
                            </div>
                            <div className="flex items-center gap-2 pl-4">
                                <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                <span className="text-gray-800 font-medium text-sm">
                                    {selectedAppointment.time ? `${selectedAppointment.time} hs` : "Hora a confirmar"}
                                </span>
                            </div>
                        </div>
                    </>
                )}

                {selectedAppointment?.status >= 3 && (
                    <p className="text-lg font-bold text-gray-900 text-center mt-8">
                        Usted ha{" "}
                        {selectedAppointment?.status === 4 ? (
                            <span>
                                <span className="text-red-600">Cancelado</span> su turno
                            </span>
                        ) : (
                            <span>
                                <span className="text-green-600">Confirmado</span> su turno
                            </span>
                        )}
                    </p>
                )}
            </div>

            {/* Buttons at bottom */}
            {selectedAppointment?.status < 3 && (
                <div className="px-6 pb-8 pt-4">
                    <button
                        disabled={loading}
                        onClick={() => handleUpdate({ status: 3 })}
                        className="w-full py-4 rounded-2xl bg-indigo-500 text-white font-semibold text-lg hover:bg-indigo-600 transition-all disabled:opacity-50 mb-3"
                    >
                        Confirmar asistencia
                    </button>
                    <button
                        disabled={loading}
                        onClick={() => handleUpdate({ status: 4, time: null, unscheduled: true })}
                        className="w-full py-3 text-red-400 font-medium text-base hover:text-red-500 transition-all disabled:opacity-50"
                    >
                        No podré asistir
                    </button>
                </div>
            )}
        </div>
    );
};
